import {
  ADDRESS_BOOKS_FETCH_STARTED,
  ADDRESS_BOOKS_FETCH_SUCCEEDED,
  ADDRESS_BOOKS_FETCH_FAILED,
  ADDRESS_BOOKS_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  addressbooks: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case ADDRESS_BOOKS_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case ADDRESS_BOOKS_FETCH_SUCCEEDED:
      return {
        ...state,
        status: statuses.succeeded,
        addressbooks: action.payload
      };
    case ADDRESS_BOOKS_FETCH_FAILED:
      return { ...state, status: statuses.failed, addressbooks: [], error: action.error };
    case ADDRESS_BOOKS_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
